import React from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        toolbar: {
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        content: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: theme.spacing(0,3,0,3),
        },
    }),
);

export default function ContentBody(props: { children?: React.ReactNode }) {
    const classes = useStyles();

    return (
        <main className={classes.content}>
            <div className={classes.toolbar} />
                {props.children}
        </main>
    );
}